import { connect } from 'react-redux';
import {
  confirmRetriggerScenarios,
  modal as modalActions
} from '../actions';

import ConfirmationModalComponent
  from '../Components/ConfirmationModalComponent';
import { owners } from '../helpers/modals';
import { getModalVisibility } from './../reducers';

export const mapStateToProps = (state) => {
  const visible = getModalVisibility(state, owners.retriggerScenarios);
  const title = 'Confirm Retrigger Scenarios';
  const confirmText = 'Confirm';
  const cancelText = 'Cancel';
  return {
    visible,
    title,
    confirmText,
    cancelText
  };
};

export const mapDispatchToProps = (dispatch, ownProps) => {
  return {
    onCancel: () => dispatch(modalActions.showRetriggerScenariosModal(false)),
    onConfirm: () => {
      dispatch(confirmRetriggerScenarios(ownProps.scenarios));
      dispatch(modalActions.showRetriggerScenariosModal(false)); }
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ConfirmationModalComponent);


// WEBPACK FOOTER //
// src/Containers/RetriggerScenariosModalContainer.jsx